import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import * as XLSX from "xlsx";
import {
  requestAddForbiddenNumber,
  requestDelForbiddenNumber,
  requestForbiddenNumbersList,
  requestImportForbiddenList,
} from "../redux/forbiddenNumbers/action";
import AddForbiddenNumbers from "../containers/AddForbiddenNumbers";
import { ListControlContainerStyles, ListHeaderStyles } from "./BlackListPage";
import { TableContainerStyles, TableStyle } from "../components/styles/Table";
import Loader from "../components/Loader/Loader";
import moment from "moment";
import { ErrorMessage } from "../components/styles/ErrorMessag";
import Button from "../components/Button/Button";
import TrashIcon from "../media/images/trash-icon";
import FileInput from "../components/FileInput";
import styled from "styled-components";

const ControlContainerStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const ForbiddenNumbers = () => {
  const { error, forbiddenNumberList, loader, total } = useSelector(
    (state) => state.forbiddenList
  );
  const [file, setFile] = useState(null);
  const fileRef = useRef();
  const [xlsxArr, setXlsxArr] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [{ login, code }] = useCookies();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      requestForbiddenNumbersList({
        login,
        code,
        data: { count: 100, lastId: 0 },
      })
    );
    //eslint-disable-next-line
  }, []);

  const deleteNumber = (number) => {
    dispatch(requestDelForbiddenNumber({ login, code, number })).then(
      (res) =>
        res.code === 0 &&
        dispatch(
          requestForbiddenNumbersList({
            login,
            code,
            data: {
              count:
                forbiddenNumberList.length < 100
                  ? 100
                  : forbiddenNumberList.length,
              lastId: 0,
            },
          })
        )
    );
  };

  const addNumber = (number) => {
    return dispatch(requestAddForbiddenNumber({ login, code, number })).then(
      (res) =>
        res.code === 0 &&
        dispatch(
          requestForbiddenNumbersList({
            login,
            code,
            data: {
              count:
                forbiddenNumberList.length < 100
                  ? 100
                  : forbiddenNumberList.length,
              lastId: 0,
            },
          })
        )
    );
  };

  const updateList = () => {
    dispatch(
      requestForbiddenNumbersList({
        login,
        code,
        data: {
          count: 100,
          lastId:
            forbiddenNumberList.length === 0
              ? 0
              : forbiddenNumberList[forbiddenNumberList.length - 1].id,
        },
        array: forbiddenNumberList,
      })
    );
  };

  const checkColumnOrder = (obj) => {
    let isValidColumns = false;
    const arrKeyColumn = Object.keys(obj);
    arrKeyColumn.forEach((key, index) => {
      if (arrKeyColumn[index] === "Value" && index === 0) {
        isValidColumns = true;
      } else if (arrKeyColumn[index] === "Date" && index === 1) {
        isValidColumns = true;
      } else {
        isValidColumns = false;
      }
    });
    return isValidColumns;
  };

  const importFile = () => {
    dispatch(requestImportForbiddenList(login, file, code)).then((res) => {
      if (res.code === 0) {
        dispatch(
          requestForbiddenNumbersList({
            login,
            code,
            data: { count: 100, lastId: 0 },
          })
        );
        if (fileRef.current) {
          fileRef.current.value = null;
          setFile(null);
          setXlsxArr([]);
        }
      }
    });
  };

  const handleChangeFile = (e) => {
    setErrorMessage(null);
    const files = e.target.files[0];
    if (files) {
      const fileType = files.name.split(".").pop();
      if (fileType === "xlsx" || fileType === "xls") {
        setFile(files);
        readFile(files);
      } else {
        fileRef.current.value = null;
        setErrorMessage("Некорректный формат файла, требуется XLSX или XLS");
      }
    }
  };

  const readFile = (oFile) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      const data = e.target.result;
      const workbook = XLSX.read(data, {
        type: "binary",
      });

      workbook.SheetNames.forEach(function (sheetName) {
        const XL_row_object = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (checkColumnOrder(XL_row_object[0])) {
          setXlsxArr(XL_row_object);
        } else {
          fileRef.current.value = null;
          setFile(null);
          setXlsxArr([]);
          setErrorMessage("Проверьте поля в файле");
        }
      });
    };
    if (oFile) {
      reader.readAsArrayBuffer(oFile);
    }
  };

  const clearFile = () => {
    if (fileRef.current) {
      fileRef.current.value = null;
      setFile(null);
      setXlsxArr([]);
    }
  };

  const exportForbiddenListToXlsx = () => {
    const listForXlsxFile = forbiddenNumberList.map((item) => ({
      Value: item.number,
      Date: item.date,
    }));

    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.json_to_sheet(listForXlsxFile);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "ForbiddenNumbers.xlsx");
  };

  return (
    <div>
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
      <ListControlContainerStyles>
        <AddForbiddenNumbers addNumber={addNumber} />
      </ListControlContainerStyles>
      <ControlContainerStyles>
        <FileInput
          fileSelect={handleChangeFile}
          file={file}
          ref={fileRef}
          clear={clearFile}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />
        {file && xlsxArr.length > 0 ? (
          <Button onClick={importFile}>Загрузить список</Button>
        ) : null}
      </ControlContainerStyles>

      <ListControlContainerStyles>
        <Button onClick={exportForbiddenListToXlsx}>Экспорт в XLSX</Button>
      </ListControlContainerStyles>

      {file && xlsxArr.length > 0 ? (
        <TableContainerStyles>
          <>
            <ListHeaderStyles>
              <h3>Список запрещенных номеров из файла</h3>
            </ListHeaderStyles>
            <TableStyle forbiddenList>
              <div className="table-header-item">№</div>
              <div className="table-header-item">Номер</div>
              <div className="table-header-item">Дата</div>
              <div className="table-header-item" />
            </TableStyle>
            {xlsxArr.map((item, index) => (
              <TableStyle key={item.Value} forbiddenList>
                <div className="table-item">{index + 1}</div>
                <div className="table-item table-item--bold">{item.Value}</div>
                <div className="table-item">
                  {item.Date
                    ? moment(item.Date, "YYYYMMDDhhmmss").format(
                        "DD.MM.YYYY HH:mm"
                      )
                    : "-"}
                </div>
                <div className="table-item table-item--delete" />
              </TableStyle>
            ))}
          </>
        </TableContainerStyles>
      ) : (
        <TableContainerStyles>
          {loader && <Loader />}
          {forbiddenNumberList.length > 0 ? (
            <>
              <ListHeaderStyles>
                <h3>Список запрещенных номеров</h3>{" "}
                {total && <span>Количество: {total}</span>}
              </ListHeaderStyles>
              <TableStyle forbiddenList>
                <div className="table-header-item">№</div>
                <div className="table-header-item">Номер</div>
                <div className="table-header-item">Дата</div>
                <div className="table-header-item" />
              </TableStyle>
              {forbiddenNumberList.map((item, index) => (
                <TableStyle key={item.number} forbiddenList>
                  <div className="table-item">{index + 1}</div>
                  <div className="table-item table-item--bold">
                    {item.number}
                  </div>
                  <div className="table-item">
                    {moment(item.date, "YYYYMMDDhhmmss").format(
                      "DD.MM.YYYY HH:mm"
                    )}
                  </div>
                  <div
                    className="table-item table-item--delete"
                    title="Удалить"
                  >
                    <button onClick={() => deleteNumber(item.number)}>
                      <TrashIcon size={16} color={"#000"} />
                    </button>
                  </div>
                </TableStyle>
              ))}
              {total > 100 && (
                <Button updateList onClick={updateList}>
                  Загрузить ещё
                </Button>
              )}
            </>
          ) : (
            !loader && <h3>Список номеров пуст</h3>
          )}
        </TableContainerStyles>
      )}
    </div>
  );
};

export default ForbiddenNumbers;
